export default __webpack_public_path__ + "static/media/Set4_2-min2.6f63964a.png";